import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-white/5 overflow-hidden" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
        <div className="md:col-span-5">
          <Logo testId="footer-logo" />
          <p className="mt-4 text-sm text-[#8A8D98] leading-relaxed max-w-sm">
            One private desk for land, luxury residences, market-linked growth and protection.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono-lux text-[10px] uppercase tracking-[0.3em] text-[#8A8D98] mb-5">Portfolio</p>
          {["Land Acquisition", "Luxury Apartments", "Mutual Funds", "Insurance"].map((x) => (
            <p key={x} className="text-sm text-[#B9BCC4] py-1.5">{x}</p>
          ))}
        </div>
        <div className="md:col-span-4">
          <p className="font-mono-lux text-[10px] uppercase tracking-[0.3em] text-[#8A8D98] mb-5">Contact</p>
          <a href="mailto:desk@keyscapeadvisory.com" data-testid="footer-email-link" className="group flex items-center gap-2 text-sm text-[#B9BCC4] hover:text-[#C8A97E] transition-colors py-1.5">
            desk@keyscapeadvisory.com
            <ArrowUpRight size={13} className="opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
          <p className="text-sm text-[#B9BCC4] py-1.5">Mon — Sat, 9:30 AM — 6:30 PM IST</p>
        </div>
      </div>
      <div className="select-none pointer-events-none text-center" aria-hidden="true">
        <span className="font-display text-[16vw] leading-[0.8] text-white/[0.04] tracking-tight">KEYSCAPE</span>
      </div>
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-white/5">
        <p className="font-mono-lux text-[10px] uppercase tracking-[0.25em] text-[#8A8D98]">© 2026 Keyscape Advisory</p>
        <div className="flex gap-8">
          {["Privacy", "Terms", "Disclosures"].map((x) => (
            <a key={x} href="#contact" data-testid={`footer-link-${x.toLowerCase()}`} className="font-mono-lux text-[10px] uppercase tracking-[0.25em] text-[#8A8D98] hover:text-[#C8A97E] transition-colors">
              {x}
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);
